import React, { useState } from "react";
import { MenuItems } from "./EventMenuItems";
import { Link } from "react-scroll";
import "./EventsDropdown.css";

function EventsDropdown() {
  const [click, setClick] = useState(false)

  const handleClick = () => setClick(!click)

  return(
    <>
      <ul onClick={handleClick}
      className={click ? 'aboutus-dropdown-menu clicked' : 'aboutus-dropdown-menu'}>
        {MenuItems.map((item, index) => {
          return (
            <li key={index}>
              <Link className={item.cName} to={item.path} onClick={() => setClick(false)}>
                {item.title}
              </Link>
            </li>
          )
        })}
      </ul>
    </>
  )
}
  
export default EventsDropdown
  
  